'use strict';

var dateFns = require('date-fns');

const getTimeInterval = ({
  start,
  end,
  step
}) => {
  if (dateFns.isEqual(start, end)) {
    return [new Date(start)];
  }
  return dateFns.eachMinuteOfInterval(
    {
      start,
      end
    },
    { step }
  );
};

exports.getTimeInterval = getTimeInterval;
//# sourceMappingURL=getTimeInterval.cjs.map
